import styled from "styled-components";

export const AddressDisplay = styled.div`
  border-radius: ${props => props.theme.borderRadius.lg};
  border: 1px solid ${props => props.theme.colors.gray8};
  width: 100%;
`;
